import styled from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';
import { isIE } from 'utils/window';

export const ChecklistWrapper = styled.div`
    & > ul {
        padding-left: 0;

        & > li:before {
            display: none;
        }
    }
`;

export const ChecklistProgressWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;

    ${media.small`
        display: block;
    `}
`;
export const ProgressBarArea = styled.div`
    height: ${isIE() ? 'auto' : '74px'};

    ${media.small`
        height: ${isIE() ? 'auto' : '94px'};
    `}
`;

type ChecklistProgressAdaptWrapperProps = {
    scrollWidth: number;
}
export const ChecklistProgressAdaptWrapper = styled.div<ChecklistProgressAdaptWrapperProps>`
    width: 100%;
    z-index:5;

    &.sticky {
        position: fixed;
        top: 0;
        left:0;
        background: ${props => props.theme.colors.contentBodyColor};
        border-bottom: 2px solid ${props => transparentize(props.theme.colors.textColor, 0.08)};
        transform: translateZ(0);
        padding-right: ${props => `${props.scrollWidth}px`};

        ${ChecklistProgressWrapper} {
            margin: 0 auto;
            width: 880px;

            ${media.xlarge`
                width: 750px;
            `}

            ${media.tablet`
                width: 560px;
            `}
            
            ${media.small`
                padding: 30px 30px 0 30px;
                width: 100%;
            `};
        }
    }
`;

export const ProgressBarContainer = styled.div`
    flex: 1;
    height: 4px;
    border-radius: 4px;
    overflow: hidden;
    background: ${props => transparentize(props.theme.colors.textColor, 0.05)};
    margin-right: 14px;

    ${media.small`
        width: 100%;
        margin: 0;
    `}
`;

type ProgressBarSubscriptionProps = {
    checkListProgress?: number;
}

export const ProgressBarSubscription = styled.span<ProgressBarSubscriptionProps>`
    font-family: ${props => props.theme.fonts.secondaryFont.fontFamily};
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.checkListProgress === 100 ? props.theme.colors.textColor : transparentize(props.theme.colors.textColor, 0.5)};
    line-height: 1;

    ${media.mobile`
        font-size: 12px;
    `}

    ${media.tablet`
        padding: 8px 0;
    `}
`;
